import { useInfiniteQuery } from '@tanstack/react-query';
import { ICompanyAggregateActivity, ImpersonationBroker, IPagedCollection } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'reports/company/bySearchQuery';

export function useReportsCompanyBySearchQuery({
	enabled,
	endDate,
	startDate,
	searchQuery,
	pageSize = 25,
}: {
	enabled?: boolean;
	endDate: Date;
	startDate: Date;
	searchQuery: string;
	pageSize?: number;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		enabled,
		queryKey: [BASE_QUERY_KEY, endDate, startDate, searchQuery, pageSize],
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<IPagedCollection<ICompanyAggregateActivity>>(
				ImpersonationBroker.composeApiUrl({
					urlPath: `reports/company/bySearchQuery`,
					queryParams: {
						pageSize,
						pageToken: pageParam,
					},
				}),
				'POST',
				{ endDate, startDate, searchQuery }
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		initialPageParam: '',
	});
}
